import { DirectUpload } from "@rails/activestorage";

export const useDirectUpload = (controller, options = {}) => {
  const delegate = {
    directUploadWillCreateBlobWithXHR(...args) {
      controller.dispatch('before-blob-request');
    },

    directUploadWillStoreFileWithXHR(...args) {
      controller.dispatch('before-storage-request');
    }
  };

  Object.assign(controller, {
    async upload(filename, blob) {
      // Ensure blob has a name for Rails' BlobRecord
      Object.assign(blob, {
        name: filename
      });

      return new Promise((resolve, reject) => {
        const directUpload = new DirectUpload(
          blob, this.directUploadUrlValue, delegate
        );

        directUpload.create((err, attachment) => {
          if (err) reject(err);
          else resolve(attachment);
        });
      });
    }
  });
};
